module.exports = __webpack_public_path__ + "img/icon-smarthome.svg";